import CurrencyFormatSection from './CurrencyFormatSection';
import PreferredCurrencySection from './PreferredCurrencySection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoardTab = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PreferredCurrencySection, {}), /*#__PURE__*/_jsx(CurrencyFormatSection, {})]
  });
};
export default BoardTab;